module.exports = __webpack_public_path__ + "static/media/mark.f77dc2b7.png";